import { ChooseWhenBookBannerVariant } from '@msc-b2c/interfaces/enums';
import { DiningChooseWhenBookPropsLike } from '@msc-b2c/interfaces/interfaces';

/**
 * Banner content resolvers for CHOOSE_WHEN_BOOK step.
 *
 * Strategy:
 * - Pick variant-specific copy first.
 * - Fallback to default info copy when variant-specific fields are missing.
 */

/**
 * Resolves title text for selected banner variant.
 */
export const resolveChooseWhenBookInfoTitle = (
  variant: ChooseWhenBookBannerVariant,
  props?: DiningChooseWhenBookPropsLike
): string | undefined => {
  switch (variant) {
    case ChooseWhenBookBannerVariant.GENERIC:
      return props?.genericErrorMessageTitle ?? props?.infoMessageTitle;
    case ChooseWhenBookBannerVariant.RESERVATION_UNAVAILABLE:
      return props?.unavailableMessageTitle ?? props?.infoMessageTitle;
    default:
      return props?.infoMessageTitle;
  }
};

/**
 * Resolves body text for selected banner variant.
 */
export const resolveChooseWhenBookInfoBody = (
  variant: ChooseWhenBookBannerVariant,
  props?: DiningChooseWhenBookPropsLike
): string | undefined => {
  switch (variant) {
    case ChooseWhenBookBannerVariant.GENERIC:
      return props?.genericErrorMessageBody ?? props?.infoMessageBody;
    case ChooseWhenBookBannerVariant.RESERVATION_UNAVAILABLE:
      return props?.unavailableMessageBody ?? props?.infoMessageBody;
    default:
      return props?.infoMessageBody;
  }
};

/**
 * Resolves icon id for selected banner variant.
 */
export const resolveChooseWhenBookInfoIcon = (
  variant: ChooseWhenBookBannerVariant,
  props?: DiningChooseWhenBookPropsLike
): string | undefined => {
  switch (variant) {
    case ChooseWhenBookBannerVariant.GENERIC:
      return props?.genericErrorMessageIcon ?? props?.infoMessageIcon;
    case ChooseWhenBookBannerVariant.RESERVATION_UNAVAILABLE:
      return props?.unavailableMessageIcon ?? props?.infoMessageIcon;
    default:
      return props?.infoMessageIcon;
  }
};

/**
 * Resolves background color for selected banner variant.
 */
export const resolveChooseWhenBookInfoBgColor = (
  variant: ChooseWhenBookBannerVariant,
  props?: DiningChooseWhenBookPropsLike
): string | undefined => {
  switch (variant) {
    case ChooseWhenBookBannerVariant.GENERIC:
      return props?.genericErrorMessageBgColor ?? props?.infoMessageBgColor;
    case ChooseWhenBookBannerVariant.RESERVATION_UNAVAILABLE:
      return props?.unavailableMessageBgColor ?? props?.infoMessageBgColor;
    default:
      return props?.infoMessageBgColor;
  }
};

/**
 * Resolves font color for selected banner variant.
 */
export const resolveChooseWhenBookInfoFontColor = (
  variant: ChooseWhenBookBannerVariant,
  props?: DiningChooseWhenBookPropsLike
): string | undefined => {
  switch (variant) {
    case ChooseWhenBookBannerVariant.GENERIC:
      return props?.genericErrorMessageFontColor ?? props?.infoMessageFontColor;
    case ChooseWhenBookBannerVariant.RESERVATION_UNAVAILABLE:
      return props?.unavailableMessageFontColor ?? props?.infoMessageFontColor;
    default:
      return props?.infoMessageFontColor;
  }
};
